import React from 'react';

export interface EmptyStateProps {
  /** Emoji or icon shown at the top */
  emoji: string;
  /** Primary heading */
  title: string;
  /** Secondary description text */
  description?: string;
  /** Optional call-to-action (e.g. a Button) */
  action?: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Centred empty-state block used when a list has no items.
 * Accepts an optional CTA action (usually a Button).
 */
export function EmptyState({ emoji, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`py-16 text-center ${className}`}>
      <p className="text-4xl" aria-hidden="true">{emoji}</p>
      <p className="mt-3 font-display text-base font-semibold text-gray-700">{title}</p>
      {description && (
        <p className="mt-1 font-body text-sm text-gray-400">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
